<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->
<template>
  <div class="animated fadeIn">
    <template v-if="base">
    <List v-show="list" ref="list" />
    </template>
    <Edit v-if="edit" @refresh="refresh" />
    <Detail v-if="detail" @refresh="refresh" />
  </div>
</template>

<script>

import List from './U.Pattern.List';
import Detail from './U.Pattern.Detail';
import Edit from './U.Pattern.Edit';

export default {
  components: { List, Detail, Edit },
  data: () => ({ base: false, list: false, edit: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = this.edit = false); }
      else if(id === 'add' || tag === 'edit') { this.edit = !(this.detail = this.list = false); }
      else { this.detail = !(this.list = this.edit = false); }
    }
  },
  created: function() { console.log('u.pattern.vue', 'created'); },
  destroyed: function() { console.log('u.pattern.vue', 'destroyed'); },
  mounted: function() {
    console.log('u.pattern.vue', 'mounted');
    this.select(this.$route.params);
  },
  watch: {
    '$route' (to, from) {
      console.log('u.pattern.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
</script>
